/**
 * HeroSection Component (Services Page)
 *
 * Renders a visually rich hero section for the Services page.
 * Features:
 * - Responsive height for mobile, tablet, and desktop (matches Figma spec)
 * - Layered background: radial gradient, image, and linear gradient overlay for depth and contrast
 * - Centered, responsive title using custom font
 *
 * @returns {JSX.Element} The hero section with background and title
 */
'use client';

import React from 'react';

export default function HeroSection() {
  return (
    <section
      className="
        relative 
        w-full 
        h-[300px]           /* Mobile default height */
        sm:h-[500px]        /* Small screens */
        md:h-[700px]        /* Medium screens */
        lg:h-[881px]        /* Desktop exact Figma height */
        overflow-hidden
      "
      style={{
        // Layered backgrounds: radial gradient, image, and linear gradient overlay
        backgroundImage: `
          radial-gradient(circle at 80% 50%, rgba(0,0,0,0) 0%, rgba(0,0,0,0.3) 100%),
          url('/images/services/andoria-ai-services-header.jpg'),
          linear-gradient(90deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0.7) 100%)
        `,
        backgroundRepeat: 'no-repeat, no-repeat, no-repeat',
        backgroundSize: 'cover, cover, cover',
        backgroundPosition: 'center, center, center',
      }}
    >
      {/* Centered Title */}
      <div className="absolute inset-0 flex items-center justify-center px-4">
        <h1
          className="
            font-manrope font-semibold text-white text-3xl   /* Mobile */
            sm:text-4xl /* Small screens */
            md:text-5xl /* Medium screens */
            lg:text-7xl /* Desktop */
            text-center 
            tracking-[-1.44px] 
            leading-tight
          "
        >
          Services
        </h1>
      </div>
    </section>
  );
}
